module.exports = __webpack_public_path__ + "media/whoosh.0fab9a02.mp3";